// extracted by mini-css-extract-plugin
export default {"modalBody":"IKDgW","name":"EwxVG","text":"Q0955","textBold":"ooOtD","buttons":"rOziD"};